// extracted by mini-css-extract-plugin
export var base = "_1g-0";
export var updateBanner = "_1g-1";